<template>
  <portlet
      :title="$t('shopfloor.trackAndTrace.scanTraceableProduct')"
      :icon="'fad fa-map-signs'"
      class="mb-3"
  >
    <template slot="portletBody">
      <div style="text-align: center; animation: blink 5s infinite; font-size: 8rem;"><span
          class="far fa-barcode-read"></span></div>
      <p class="scan-instruction">{{ $t('shopfloor.loodsopname.scanProduct') }}</p>
      <div class="manual-barcode-input-bottom barcode-input">
        <form @submit.prevent="barcodeScanned(manualBarcode)">
          <label for="manual-barcode">{{ $t('shopfloor.loodsopname.manualBarcode') }}</label>
          <div class="d-flex">
            <input type="text" id="manual-barcode" class="form-control" v-model="manualBarcode"/>
            <button class="btn btn-primary" type="submit">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </form>
      </div>
    </template>
  </portlet>
</template>

<script>
export default {
  name: "ScanTraceableProduct",
  data() {
    return {
      manualBarcode: ''
    };
  },
  methods: {
    async barcodeScanned(barcode) {
      if (!this.lastResponse) {
        this.$store.commit('setLoading', true);
        const response = await this.checkBarcode(barcode);
        this.$store.commit('setLoading', false);
        if (response === 'BARCODE_NOT_FOUND') {
          this.showUnknownBarcodeToast();
        } else if (!response) {
          this.showSomethingWentWrongToast();
        } else {
          return this.$router.push({name: 'TrackAndTrace', params: { productNumber: barcode }});
        }
      }
    },
    async checkBarcode(barcode) {
      let token = JSON.parse(localStorage.getItem('motivate-token')).oauthToken;
      try {
        const res = await this.$CLOUD_API.get(`/products/${barcode}`, {
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        return res.data;
      } catch (e) {
        return null;
      }
    },
    showSomethingWentWrongToast() {
      this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'error',
        title: this.$t('shopfloor.loodsopname.requestFailed')
      });
    },
    showUnknownBarcodeToast() {
      this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'error',
        title: this.$t('shopfloor.loodsopname.unknownBarcode')
      });
    },
    resetProgress() {
      this.manualBarcode = '';
    }
  },
  async beforeRouteLeave(from, to, next) {
    this.resetProgress();
    await this.$barcodeScanner.barCodeEventBus.$off('barcodeScanned', this.barcodeScanned);
    next();
  },
  created() {
    this.resetProgress();
    this.$barcodeScanner.barCodeEventBus.$on('barcodeScanned', this.barcodeScanned);
  }
}
</script>

<style scoped>

</style>